{
	/* Allineare colore con la difficoltà vedi ResearchScreen */
}
import {
	View,
	Text,
	SafeAreaView,
	StatusBar,
	TouchableOpacity,
	ScrollView,
	ActivityIndicator,
} from "react-native";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import ExerciseAnswer from "../components/ExerciseAnswer";
import DifficultyText from "../components/DifficultyText";
import TokenComponent from "../components/TokenComponent";
import axios from "axios";
import { sessionData } from "../utils/firebase";
import { showDifficultyIt } from "../utils/translation";
import { Difficulty, Problem } from "../types/Problem";
import { requestedProblems } from "../state/problems";
import { userData } from "../state/user";
import ProblemComponent from "../components/ProblemComponent";

const SuggestedProblem = () => {
	const navigation = useNavigation();

	useLayoutEffect(() => {
		navigation.setOptions({
			headerTitleAlign: "center",
			headerStyle: {
				backgroundColor: "#263238",
			},
			headerTitleStyle: {
				color: "white",
			},
			headerTintColor: "white",
			headerShadowVisible: false,
		});
	}, []);

	async function getProblem({ reset }: { reset: boolean }) {
		setProblemState("requesting");
		if (requestedProblems.suggestedProblem) {
			setProblem(requestedProblems.suggestedProblem);
			setProblemState("solving");
		} else {
			try {
				const response = await axios.get(
					// "https://europe-west3-matemattici-training.cloudfunctions.net/problems/",
					`https://europe-west3-matemattici-training.cloudfunctions.net/problems/suggested${
						reset ? "?reset=true" : ""
					}`,
					{
						headers: {
							"Content-Type": "application/json",
							Authorization: "Bearer " + sessionData.idToken,
						},
					}
				);
				setProblem(response.data.problem);
				setProblemState("solving");
				requestedProblems.suggestedProblem = response.data.problem;
				userData.requested_problems = null;
				userData.submissions = null;
			} catch (error) {
				setProblemState("gotError");
			}
		}
	}

	async function postSolution() {
		setProblemState("waitingForAnswer");
		try {
			const response = await axios.post(
				`https://europe-west3-matemattici-training.cloudfunctions.net/problems/${problem?.id.toString()}`,
				{ answer: selectedAnswer },
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + sessionData.idToken,
					},
				}
			);
			if (response.data.correct) {
				requestedProblems.suggestedProblem = null;
				setProblemState("gotCorrectAnswer");
			} else {
				setProblemState("gotWrongAnswer");
			}
			userData.requested_problems = null;
			userData.submissions = null;
		} catch (error) {
			setProblemState("gotError");
		}
	}

	const [problem, setProblem] = useState<null | Problem>(null);

	// doingNothing, requesting, solving, waitingForAnswer, gotCorrectAnswer, gotWrongAnswer, gotError
	const [problemState, setProblemState] = useState("doingNothing");

	useEffect(() => {
		if (problemState === "doingNothing") {
			getProblem({ reset: false });
		}
	}, []);

	const [selectedAnswer, setSelectedAnswer] = useState<number | null>(null);

	return (
		<ProblemComponent
			problem={problem}
			setProblem={setProblem}
			problemState={problemState}
			setProblemState={setProblemState}
			selectedAnswer={selectedAnswer}
			setSelectedAnswer={setSelectedAnswer}
			getProblem={getProblem}
			postSolution={postSolution}
			canSkip={true}
			name={"suggestedProblem"}
		/>
	);
};

export default SuggestedProblem;
